import React from "react";
import { motion } from "framer-motion";
import { Reveal } from "./Reveal";
import { GALLERY } from "../../data/content";

export const Gallery = () => (
  <section id="gallery" className="relative py-24 md:py-40 border-t border-brand-line bg-brand-surface/40" data-testid="gallery-section">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <Reveal className="mb-16 max-w-2xl">
        <p className="overline mb-6">06 — In practice</p>
        <h2 className="font-display font-light text-4xl md:text-6xl tracking-tight text-brand-text leading-[1.02]">
          Moments from the field.
        </h2>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
        {GALLERY.map((g, i) => (
          <Reveal key={g.title} delay={i * 0.1}>
            <figure className="group" data-testid={`gallery-item-${i}`}>
              <div className="relative aspect-[4/3] overflow-hidden border border-brand-line">
                <motion.img
                  src={g.src}
                  alt={g.title}
                  loading="lazy"
                  className="w-full h-full object-cover transition-[transform,filter] duration-700 grayscale group-hover:grayscale-0 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-brand-base/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                <span className="absolute top-4 left-4 font-mono text-[10px] uppercase tracking-[0.2em] text-brand-base bg-brand px-2.5 py-1">
                  {String(i + 1).padStart(2, "0")}
                </span>
              </div>
              <figcaption className="mt-5">
                <h3 className="font-display text-2xl text-brand-text">{g.title}</h3>
                <p className="mt-2 text-sm text-brand-soft font-light leading-relaxed">{g.caption}</p>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Gallery;
